// Core component styles
const coreStyles = {
    anchorScrollColumn: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 0 0',
        overflowY: 'auto',
    },

    mainContentRowSizingContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex: '1 0 auto',
        overflowY: 'hidden',
        overflowX: 'auto',
        height: '100%',
    },

    column: {
        display: 'flex',
        flexDirection: 'column',
        // flex: '1 0 auto',
        minWidth: '600px',
    },
};

/**
 * Helper method to get the styles and merge with context styles
 * @param {Object} contextStyles
 */
const getStyles = (contextStyles = {}) => {
    return {
        anchorScrollColumn: {
            ...coreStyles.anchorScrollColumn,
            ...contextStyles.anchorScrollColumn,
        },

        mainContentRowSizingContainer: {
            ...coreStyles.mainContentRowSizingContainer,
            ...contextStyles.mainContentRowSizingContainer,
        },

        column: {
            ...coreStyles.column,
            ...contextStyles.column,
        },
    };
};

export default getStyles;
